'use client';

import Icon from '@/components/ui/AppIcon';

const metrics = [
  {
    label: 'Olay / sn',
    value: '4,218',
    unit: 'eps',
    change: '+8.3%',
    changeDir: 'up',
    changeColor: 'text-emerald-400',
    icon: 'BoltIcon',
    iconColor: 'text-emerald-500',
    iconBg: 'bg-emerald-500/10',
    sparkData: [3800, 4100, 3950, 4300, 4218, 4180, 4218],
    sparkColor: '#10b981',
    status: 'normal',
  },
  {
    label: 'Kritik Olaylar',
    value: '4',
    unit: 'açık',
    change: '+2 bugün',
    changeDir: 'up',
    changeColor: 'text-red-400',
    icon: 'ExclamationCircleIcon',
    iconColor: 'text-red-500',
    iconBg: 'bg-red-500/10',
    sparkData: [1, 1, 2, 2, 3, 3, 4],
    sparkColor: '#ef4444',
    status: 'alert',
  },
  {
    label: 'MTTD',
    value: '3.2',
    unit: 'dak',
    change: '-0.4 dak',
    changeDir: 'down-good',
    changeColor: 'text-emerald-400',
    icon: 'ClockIcon',
    iconColor: 'text-blue-400',
    iconBg: 'bg-blue-500/10',
    sparkData: [4.1, 3.9, 3.7, 3.8, 3.5, 3.3, 3.2],
    sparkColor: '#3b82f6',
    status: 'normal',
  },
  {
    label: 'MTTR',
    value: '18.7',
    unit: 'dak',
    change: '+2.1 dak',
    changeDir: 'up-bad',
    changeColor: 'text-orange-400',
    icon: 'WrenchScrewdriverIcon',
    iconColor: 'text-orange-400',
    iconBg: 'bg-orange-500/10',
    sparkData: [15.2, 16.1, 14.9, 17.3, 18.1, 18.5, 18.7],
    sparkColor: '#f97316',
    status: 'warning',
  },
  {
    label: 'Alarm Yorgunluğu',
    value: '34',
    unit: '% YP oranı',
    change: '-5% vs 7g ort',
    changeDir: 'down-good',
    changeColor: 'text-emerald-400',
    icon: 'BellSlashIcon',
    iconColor: 'text-purple-400',
    iconBg: 'bg-purple-500/10',
    sparkData: [42, 39, 41, 38, 36, 35, 34],
    sparkColor: '#a855f7',
    status: 'normal',
  },
];

function MiniSparkline({ data, color }: { data: number[]; color: string }) {
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const w = 60;
  const h = 24;
  const pts = data.map((v, i) => {
    const x = (i / (data.length - 1)) * w;
    const y = h - ((v - min) / range) * h;
    return `${x},${y}`;
  });

  return (
    <svg width={w} height={h} className="overflow-visible">
      <polyline
        points={pts.join(' ')}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity={0.8}
      />
      {/* Last point dot */}
      <circle
        cx={parseFloat(pts[pts.length - 1].split(',')[0])}
        cy={parseFloat(pts[pts.length - 1].split(',')[1])}
        r="2"
        fill={color}
      />
    </svg>
  );
}

export default function KpiMetricCards() {
  return (
    <>
      {metrics.map((m) => (
        <div
          key={m.label}
          className={`
            bg-zinc-900 border rounded-xl p-4 flex flex-col gap-3 transition-all duration-150 hover:border-zinc-700
            ${m.status === 'alert' ? 'border-red-500/30 bg-red-500/5' : m.status === 'warning' ? 'border-orange-500/20' : 'border-zinc-800'}
          `}
        >
          <div className="flex items-center justify-between">
            <div className={`w-8 h-8 rounded-lg ${m.iconBg} flex items-center justify-center`}>
              <Icon name={m.icon as any} size={15} className={m.iconColor} />
            </div>
            {m.status === 'alert' && (
              <span className="text-[9px] font-bold uppercase tracking-widest text-red-400 bg-red-500/15 border border-red-500/20 px-1.5 py-0.5 rounded">
                Alarm
              </span>
            )}
          </div>

          <div>
            <p className="text-[11px] font-medium uppercase tracking-widest text-zinc-500">{m.label}</p>
            <div className="flex items-baseline gap-1 mt-0.5">
              <span className="text-2xl font-bold tabular-nums text-zinc-100">{m.value}</span>
              <span className="text-xs text-zinc-600">{m.unit}</span>
            </div>
          </div>

          <div className="flex items-end justify-between">
            <span className={`text-[11px] font-medium ${m.changeColor}`}>{m.change}</span>
            <MiniSparkline data={m.sparkData} color={m.sparkColor} />
          </div>
        </div>
      ))}
    </>
  );
}